import api from '@app/api'

import type { AblePaginatedResponseFn, ResponseDto } from '@app/api/dtos'
import type {
  InternalTasksListItemDto,
  InternalTaskItemDto,
  InternalTasksItemCommentsDto,
  InternalTaskItemExecutorDto
} from './dtos'
import type {
  DeleteInternalTasksCommentsData,
  GetInternalTasksCommentsParams,
  GetInternalTasksItemParams,
  GetInternalTasksParams,
  GetTaskExecutorsParams,
  PatchInternalTasksComments,
  PatchInternalTasksItemExecutorData,
  PatchInternalTasksItemExecutorSelfData,
  PostInternalTasksCommentsData,
  PostInternalTasksData,
  PostInternalTasksItemApproveData,
  PostInternalTasksItemCancelData,
  PostInternalTasksItemRejectData
} from './types'

const URL = '/internal-tasks/'

export const getInternalTasks = async (
  params?: GetInternalTasksParams
): Promise<ResponseDto<InternalTasksListItemDto>> => {
  const response = await api.get<ResponseDto<InternalTasksListItemDto>>(URL, { params })

  return response.data
}

export const getInternalTasksItem = async (params: GetInternalTasksItemParams): Promise<InternalTaskItemDto> => {
  const { id } = params
  const url = `${URL}${id}/`

  const response = await api.get<InternalTaskItemDto>(url)
  return response.data
}

export const postInternalTasksItemCancel = async ({ taskId }: PostInternalTasksItemCancelData): Promise<void> => {
  const url = `${URL}${taskId}/cancel/`

  await api.post(url)
}

export const postInternalTasksItemApprove = async ({ taskId }: PostInternalTasksItemApproveData): Promise<void> => {
  const url = `${URL}${taskId}/approve/`

  await api.post(url)
}

export const postInternalTasksItemReject = async ({ taskId }: PostInternalTasksItemRejectData): Promise<void> => {
  const url = `${URL}${taskId}/reject/`

  await api.post(url)
}

export const patchInternalTasksItemExecutor = async ({
  taskId,
  ...data
}: PatchInternalTasksItemExecutorData): Promise<void> => {
  const url = `${URL}${taskId}/executor/`

  await api.patch(url, data)
}

export const getInternalTasksComments = async ({
  taskId,
  ...params
}: GetInternalTasksCommentsParams): Promise<ResponseDto<InternalTasksItemCommentsDto>> => {
  const url = `${URL}${taskId}/comments/`

  const response = await api.get<ResponseDto<InternalTasksItemCommentsDto>>(url, { params })
  return response.data
}

export const postInternalTasksComments = async ({ taskId, ...data }: PostInternalTasksCommentsData): Promise<void> => {
  const url = `${URL}${taskId}/comments/`

  await api.post(url, data)
}

export const deleteInternalTasksComments = async ({
  taskId,
  commentId
}: DeleteInternalTasksCommentsData): Promise<void> => {
  const url = `${URL}${taskId}/comments/${commentId}/`

  await api.delete(url)
}

export const patchInternalTasksComments = async ({
  taskId,
  commentId,
  ...data
}: PatchInternalTasksComments): Promise<void> => {
  const url = `${URL}${taskId}/comments/${commentId}/`

  await api.patch(url, data)
}

export const patchInternalTasksItemExecutorSelf = async ({
  taskId
}: PatchInternalTasksItemExecutorSelfData): Promise<void> => {
  const url = `${URL}${taskId}/executor/self/`

  await api.patch(url)
}

export const createInternalTasks = async (data: PostInternalTasksData): Promise<void> => {
  await api.post(URL, data)
}

export const getTaskExecutors: AblePaginatedResponseFn<
GetTaskExecutorsParams,
InternalTaskItemExecutorDto
> = async outerParams => {
  const { taskId, ...params } = outerParams as GetTaskExecutorsParams
  const url = `${URL}${taskId}/executors/`

  const response = await api.get(url, { params })
  return response.data
}
